var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsEditFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.794 6.208l2.998 2.998L6.74 20.252 3 21l.748-3.74L14.794 6.207zm2.292-2.293a1.998 1.998 0 012.828 0l.172.17a2 2 0 010 2.829l-.88.878-2.998-2.999.878-.878z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzOSAtMTE2NykgdHJhbnNsYXRlKDEyNjEgMTE1NSkgdHJhbnNsYXRlKDc4IDEyKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTE0Ljc5NCA2LjIwOGwyLjk5OCAyLjk5OEw2Ljc0IDIwLjI1MiAzIDIxbC43NDgtMy43NEwxNC43OTQgNi4yMDd6bTIuMjkyLTIuMjkzYy43ODEtLjc4MiAyLjA0OC0uNzgyIDIuODI4IDBsLjE3Mi4xN2MuNzgxLjc4Mi43ODEgMi4wNDggMCAyLjgyOWwtLjg4Ljg3OC0yLjk5OC0yLjk5OS44NzgtLjg3OHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzM5IC0xMTY3KSB0cmFuc2xhdGUoMTI2MSAxMTU1KSB0cmFuc2xhdGUoNzggMTIpIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconsEditFilled as ReactComponent };